import { useCallback, useState } from "react";
import { APPROACH } from "@/content/site";
import ContextLine from "@/components/ContextLine";
import Reveal from "@/components/Reveal";

export default function Approach() {
  const [active, setActive] = useState(0);

  const onProgress = useCallback((v) => {
    setActive(v < 0.4 ? 0 : v < 0.75 ? 1 : 2);
  }, []);

  return (
    <section data-testid="approach-section" className="relative bg-paper py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <Reveal>
          <span className="eyebrow mb-6">منهجيتنا</span>
          <h2 className="font-display text-navy leading-tight max-w-3xl" style={{ fontSize: "clamp(1.5rem, 2.9vw, 2.5rem)" }}>
            {APPROACH.heading}
          </h2>
        </Reveal>

        {/* The copper Siaq line with a light dot threading the three stages */}
        <div className="relative mt-20">
          <ContextLine
            d="M0,60 C200,20 400,100 600,60 C800,20 1000,100 1200,60"
            viewBox="0 0 1200 120"
            className="absolute top-2 inset-x-0 h-24 w-full pointer-events-none"
            strokeWidth={2.5}
            withDot
            duration={2.7}
            onProgress={onProgress}
          />

          <div className="relative grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-8">
            {APPROACH.nodes.map((node, i) => {
              const lit = active >= i;
              return (
                <div key={node.k} className="relative">
                  <div className="flex items-center gap-4">
                    <span className="font-display text-2xl transition-colors duration-500" style={{ color: lit ? "var(--coral)" : "var(--peach)" }}>{node.k}</span>
                    <span className="h-2 w-2 rotate-45 transition-transform duration-500" style={{ backgroundColor: "var(--coral)", transform: lit ? "rotate(45deg) scale(1.4)" : "rotate(45deg) scale(1)" }} aria-hidden="true" />
                  </div>
                  <h3 className="mt-4 font-display text-2xl sm:text-3xl transition-colors duration-500" style={{ color: lit ? "var(--navy)" : "#5a7089" }}>{node.title}</h3>
                  <p className="mt-3 text-blue leading-relaxed max-w-xs">{node.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
